import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Page that presents staff members with WhatsApp links for visa assistance.
 * Uses UIKit flex layout and UIKit cards.
 * @param {*} props
 * @returns
 */
function ApplyOnboardingPage(props) {

    var { t } = useTranslation();

    var staffMembers = [
        {
            name: "company.staff.member.buba",
            phone: "77750912804",
            image: "/staff/buba.jpg"
        },
        {
            name: "company.staff.member.alex",
            phone: "77080613817",
            image: "/staff/alex.jpg"
        },
        {
            name: "company.staff.member.kwame",
            phone: "77082338790",
            image: "/staff/kwame.jpg"
        }
    ];

    return (
        <div className="uk-container uk-section">
            <h1 className="uk-heading-line uk-text-large">
                <span>
                    {t("ui.pages.applyPage.title")}
                </span>
            </h1>

            <p>
                {t("ui.pages.applyPage.description")}
            </p>

            <div
                className="uk-flex uk-flex-wrap uk-flex-center uk-margin-top"
                style={{ gap: "24px" }}
            >
                {staffMembers.map(function (member) {
                    return (
                        <div
                            key={member.phone}
                            className="uk-card uk-card-default uk-text-center"
                            style={{ width: "250px" }}
                        >
                            <div className="uk-card-media-top">
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    style={{
                                        width: "100%",
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                        borderRadius: "8px"
                                    }}
                                />
                            </div>
                            <div className="uk-card-body">
                                <h5 className="uk-card-title uk-margin-small-bottom">
                                    {t(member.name)}
                                </h5>
                                <a
                                    href={
                                        "https://wa.me/" +
                                        member.phone +
                                        "?text=Hello%20I%20want%20to%20apply%20for%20a%20Kazakhstan%20visa"
                                    }
                                    className="uk-button uk-button-jai uk-button-small"
                                >
                                    {t("infopages.landing.cta2")}
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ApplyOnboardingPage;
